import { ShareOffOutlineIcon } from './ShareOffOutlineIcon';

/**
 * author: GreenTurtwig
 * id E65D2036-B0D1-4957-B114-A6FA6DFC67A5
 * name share-off-outline
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/share-off-outline.svg
 * tags
 * - Arrow 
 */
export const ForwardOffOutlineIcon = ShareOffOutlineIcon;
export default ForwardOffOutlineIcon